import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ListResultDTO } from 'src/app/helpers/listResult.interface';
import { environment } from 'src/environments/environment';

import { IvaTypologyDTO, IvaTypologyFilters } from '../../models/iva-typology.model';

@Injectable({
  providedIn: "root"
})
export class LaravelIvaTypologyService {
  constructor(private httpClient: HttpClient) { }

  private get ROUTES() {
    return {
      list: environment.baseUrl + "/api/iva_typologies",
      show: environment.baseUrl + "/api/iva_typology",
      store: environment.baseUrl + "/api/iva_typology",
      destroy: environment.baseUrl + "/api/iva_typology",
    };
  }

  public list(page: number,
    per_page: number,
    order: string,
    direction: string,
    filters: IvaTypologyFilters,
    includes?: string[]
  ): Observable<ListResultDTO<IvaTypologyDTO>> {
    let params = {};
    if (order) params["order"] = "" + order;
    if (direction) params["direction"] = "" + direction;
    if (includes) params["includes[]"] = includes;
    if (filters) {
      if (filters.search) params["search"] = "" + filters.search;
    }
    if (per_page) {
      params["per_page"] = "" + per_page;
      if (page) params["page"] = "" + page;
      return this.httpClient.get<ListResultDTO<IvaTypologyDTO>>(this.ROUTES.list, {
        params: new HttpParams({ fromObject: params })
      });
    } else {
      return this.httpClient.get<IvaTypologyDTO[]>(this.ROUTES.list, {
        params: new HttpParams({ fromObject: params })
      }).pipe(
        map(results => {
          return {
            data: results,
            total: results.length
          };
        })
      );
    }
  }


  public show(id: number): Observable<IvaTypologyDTO> {
    let params = { id: "" + id };
    return this.httpClient.get<IvaTypologyDTO>(this.ROUTES.show, {
      params: new HttpParams({
        fromObject: params
      })
    });

  }

  public upsert(iva_typology: IvaTypologyDTO): Observable<IvaTypologyDTO> {
    if (iva_typology.id) {
      return this.httpClient.put<IvaTypologyDTO>(`${this.ROUTES.store}`, { iva_typology });
    } else {
      return this.httpClient.post<IvaTypologyDTO>(`${this.ROUTES.store}`, { iva_typology });
    }
  }

  public delete(id: number): Observable<any> {
    let params = { id: "" + id };
    return this.httpClient.delete(this.ROUTES.destroy, {
      params: new HttpParams({
        fromObject: params
      })
    });
  }
}
